// Auto-generated bank list from bancos.md
export const BANKS: { code: string; name: string }[] = [
  { code: '001', name: 'BANCO DO BRASIL S.A.' },
  { code: '003', name: 'BANCO DA AMAZÔNIA' },
  { code: '008', name: 'BANCO SANTANDER MERIDIONAL S.A.' },
  { code: '027', name: 'BANCO DO ESTADO DE SANTA CATARINA S.A.' },
  { code: '041', name: 'BANCO DO ESTADO DO RIO GRANDE DO SUL' },
  { code: '073', name: 'BANCO POPULAR DO BRASIL' },
  { code: '104', name: 'CAIXA ECONÔMICA FEDERAL' },
  { code: '151', name: 'BANCO NOSSA CAIXA' },
  { code: '175', name: 'BANCO FINASA S.A.' },
  { code: '205', name: 'BANCO SUL AMÉRICA S.A.' },
  { code: '230', name: 'BANCO BANDEIRANTES S.A.' },
  { code: '237', name: 'BANCO BRADESCO S.A.' },
  { code: '246', name: 'BANCO ABC BRASIL S/A' },
  { code: '250', name: 'BANCO SCHAHIN S/A' },
  { code: '252', name: 'BANCO FININVEST S.A.' },
  { code: '291', name: 'BANCO BCN S.A.' },
  { code: '320', name: 'BANCO INDUSTRIAL COMERCIAL S/A' },
  { code: '341', name: 'BANCO ITAÚ S.A.' },
  { code: '347', name: 'BANCO SUDAMERIS BRASIL S.A.' },
  { code: '353', name: 'BANCO SANTANDER BRASIL S.A.' },
  { code: '356', name: 'BANCO ABN AMRO REAL S.A.' },
  { code: '389', name: 'BANCO MERCANTIL DO BRASIL S.A.' },
  { code: '394', name: 'BANCO BMC S/A' },
  { code: '399', name: 'HSBC BANK BRASIL S.A. - BANCO MÚLTIPLO' },
  { code: '409', name: 'UNIBANCO - UNIÃO DE BANCOS BRASILEIROS S.A.' },
  { code: '422', name: 'BANCO SAFRA S/A' },
  { code: '453', name: 'BANCO RURAL S.A.' },
  { code: '479', name: 'BANK BOSTON - BANCO MÚLTIPLO S/A' },
  { code: '623', name: 'BANCO PANAMERICANO S/A' },
  { code: '643', name: 'BANCO PINE S/A' },
  { code: '702', name: 'BANCO SANTOS S.A.' },
  { code: '707', name: 'BANCO DAYCOVAL S/A' },
  { code: '748', name: 'BANCO COOPERATIVO SICREDI S.A. - BANSICREDI' },
  { code: '611', name: 'BANCO PAULISTA S.A.' },
  { code: '655', name: 'BANCO VOTORANTIM S.A.' },
  { code: '218', name: 'BANCO BONSUCESSO S.A' },
  { code: '487', name: 'BANCO ALEMÃO - DEUTSCHE BANK S.A.' },
  { code: '107', name: 'BANCO BBM S.A.' },
  { code: '184', name: 'BANCO ITAU BBA S.A.' },
  { code: '084', name: 'UNIPRIME NORTE DO PARANÁ - COOP DE ECONOMIA E CRÉDITO MÚTUO DOS MÉDICOS, PROFISSIONAIS DAS CIÊNCIAS' },
  { code: '136', name: 'CONFEDERACAO NACIONAL DAS COOPERATIVAS CENTRAIS UNICREDS' },
  { code: '033', name: 'BANCO SANTANDER (BRASIL) S.A.' },
  { code: '099', name: 'UNIPRIME CENTRAL CCC LTDA' },
  { code: '133', name: 'CRESOL CONFEDERAÇÃO' },
  { code: '654', name: 'BANCO RENNER' },
  { code: '290', name: 'BANCO PAGBANK' },
  { code: '044', name: 'BANCO BVA S.A.' },
  { code: '112', name: 'UNICRED BRASIL CENTRAL' },
  { code: '070', name: 'BANCO DE BRASILIA S/A' },
  { code: '077', name: 'BANCO INTER S.A.' },
  { code: '637', name: 'BANCO SOFISA S.A.' },
  { code: '260', name: 'NU PAGAMENTOS S.A.' },
  { code: '318', name: 'BANCO BMG S.A.' },
  { code: '745', name: 'BANCO CITIBANK S.A.' },
  { code: '097', name: 'COOPERATIVA CENTRAL DE CRÉDITO NOROESTE BRASILEIRO LTDA.' },
  { code: '037', name: 'BANCO DO ESTADO DO PARÁ S.A.' },
  { code: '094', name: 'BANCO PETRA S.A.' },
  { code: '999', name: 'NÃO DEFINIDO(SOMENTE RPPS)' },
  { code: '208', name: 'BANCO BTG PACTUAL S.A.' },
  { code: '004', name: 'BANCO DO NORDESTE DO BRASIL S.A.' },
  { code: '017', name: 'BNY MELLON BANCO S.A.' },
  { code: '212', name: 'BANCO ORIGINAL S.A.' },
  { code: '197', name: 'Stone Pagamentos S.A' },
  { code: '403', name: 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.' },
  { code: '336', name: 'BCO C6 S.A.' },
  { code: '085', name: 'COOPERATIVA CENTRAL DE CRÉDITO - AILOS' },
  { code: '274', name: 'MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE' },
  { code: '100', name: 'PLANNER CORRETORA DE VALORES S.A.' },
  { code: '340', name: 'SUPER PAGAMENTOS E ADMINISTRAÇÃO DE MEIOS ELETRÔNICOS S.A.' },
  { code: '323', name: 'MERCADO PAGO' },
  { code: '536', name: 'NEON' },
  { code: '280', name: 'WILL BANK' },
  { code: '380', name: 'PICPAY SERVICOS S.A.' },
  { code: '266', name: 'BANCO CEDULA S.A.' },
  { code: '102', name: 'XP INVESTIMENTOS' },
  { code: '756', name: 'SICOOB' },
  { code: '335', name: 'BANCO DIGIO S.A' },
  { code: '279', name: 'CCR DE PRIMAVERA DO LESTE' },
  { code: '224', name: 'BANCO FIBRA' },
  { code: '348', name: 'BANCO XP S.A' },
];

export function findBankByCode(code: string) {
  const normalized = code ? code.trim().padStart(3, '0') : '';
  return BANKS.find((b) => b.code === normalized) || null;
}

